import React, { useState } from "react"
import { Button, Alert, Form, FormGroup, Input, Label } from "reactstrap"
import { useLoading } from "helpers/custom_hooks"
import { UpdateCPSRequest } from "helpers/backend_helper"
import { displayMessage } from "helpers/misc_helpers"
import moment from "moment"

const CPSGoodsReceived = ({ entry, myUser, statusIndex, reload }) => {
  const setLoading = useLoading()
  const [isProcessing, setIsProcessing] = useState(false)
  const [receivedQuantity, setReceivedQuantity] = useState(
    entry?.arrivedQuantity || entry?.quantity || ""
  )

  // Determine if this step is active
  const isActive = entry?.statusIndex === 5 // Goods Shipped status
  const isCompleted = entry?.statusIndex > 5

  // Check if user is CPS Lab (can mark goods as received)
  const isCPSLab = myUser?.company?.id === entry?.cpsLabID
  const canMarkReceived = isActive && !isCompleted && isCPSLab

  const handleMarkReceived = async (e) => {
    e.preventDefault()
    
    if (!receivedQuantity || receivedQuantity <= 0) {
      displayMessage("Please enter a valid received quantity", setError)
      return
    }

    setIsProcessing(true)
    setLoading(true)
    try {
      const updatedEntry = {
        ...entry,
        dateReceived: new Date().toISOString(),
        receivedQuantity: parseInt(receivedQuantity),
        arrivedQuantity: parseInt(receivedQuantity),
        // overwrite main quantity with actually arrived quantity
        quantity: parseInt(receivedQuantity),
        statusIndex: 6, // Move to next status (Sample Production or Production)
      }

      await UpdateCPSRequest(updatedEntry)

      // Small delay to ensure backend has processed the update
      setTimeout(() => {
        reload()
      }, 500)
    } catch (error) {
      error?.response?.status == 400
        ? displayMessage(error.response.data, setError)
        : displayMessage("An unexpected error happened!", setError)
      console.log(error)
    }
    setIsProcessing(false)
    setLoading(false)
  }

  const getReceivedDate = () => {
    if (entry?.dateReceived) {
      return moment(entry.dateReceived).format("DD.MM.YYYY")
    }
    return null
  }

  return (
    <li className={"event-list " + (isActive ? "active" : "")}>
      <div
        className={"event-timeline-dot " + (isActive ? "bx-fade-right" : "")}
      >
        <i className="bx bx-right-arrow-circle font-size-18"></i>
      </div>
      <div className="d-flex">
        <div className="flex-shrink-0 me-3">
          <h5 className="font-size-14">
            {isCompleted ? getReceivedDate() : ""}{" "}
            <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
          </h5>
        </div>
        <div className="flex-grow-1">
          <div>
            Goods Received{" "}
            {isActive
              ? " - waiting for CPS Lab to confirm receipt"
              : isCompleted
              ? " - goods received by CPS Lab"
              : ""}
          </div>
        </div>
      </div>

      {isCompleted && entry?.dateReceived && (
        <div className="d-flex align-items-center mt-3">
          <div style={{ width: "45px" }}>
            <div className="avatar-sm">
              <span className="avatar-title rounded-circle bg-success bg-soft text-success font-size-24">
                <i className="bx bx-check-circle" />
              </span>
            </div>
          </div>
          <div className="ms-4">
            <h5 className="font-size-14 mb-1">Goods Received</h5>
            <small>Received on {getReceivedDate()}</small>
            {entry?.receivedQuantity && (
              <div className="mt-1">
                <small className="text-muted">
                  <i className="bx bx-package me-1"></i>
                  Quantity Received: {entry.receivedQuantity}
                </small>
              </div>
            )}
          </div>
        </div>
      )}

      {canMarkReceived && (
        <div className="mt-3">
          <Alert color="info">
            <i className="bx bx-info-circle me-2"></i>
            Please confirm that you have received the goods from the customer and enter the actual quantity received.
          </Alert>
          <Form onSubmit={handleMarkReceived}>
            <FormGroup>
              <Label>Received Quantity *</Label>
              <Input
                type="number"
                value={receivedQuantity}
                onChange={e => setReceivedQuantity(e.target.value)}
                placeholder="Enter quantity received"
                min="1"
                max={entry?.quantity}
                disabled={isProcessing}
              />
              <div className="form-text text-muted">
                Original quantity ordered: {entry?.quantity}
              </div>
            </FormGroup>
            <Button
              type="submit"
              color="success"
              size="sm"
              disabled={isProcessing || !receivedQuantity || receivedQuantity <= 0}
            >
              {isProcessing ? "Processing..." : "Mark as Received"}
            </Button>
          </Form>
        </div>
      )}
    </li>
  )
}

export default CPSGoodsReceived
